import { Fare, Porter } from '@silbo/core';
import { useQueryClient } from '@tanstack/react-query';
import { getFaresQuery } from '../../queries';

const useUpdateAssignationQueryData = (porter?: Porter) => {
  const queryClient = useQueryClient();
  return (params: { fareId: string }) => {
    if (porter) {
      queryClient.setQueryData([getFaresQuery(porter).className, getFaresQuery(porter).toJSON()], (data: Fare[]) => {
        const fareIndex = data.findIndex((fare) => fare.id === params.fareId);
        const dataCopy = [...data];
        if (fareIndex !== -1 && dataCopy[fareIndex].assignations) {
          const assignationIndex = dataCopy[fareIndex].assignations.findIndex(
            (assignation) => assignation.porter.id === porter.id
          );
          if (assignationIndex !== -1) {
            dataCopy[fareIndex].assignations[assignationIndex].acknowledgedAt = new Date();
          }
        }
        return dataCopy;
      });
    }
  };
};

export { useUpdateAssignationQueryData };
